.dropdownButton {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
